import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, throwError, switchMap, tap, filter, take, finalize } from 'rxjs';
import { Router } from '@angular/router';
import { get } from 'lodash-es';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RefreshTokenService } from './refresh-token.service';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from './shared/service/snackbar.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root'
})
export class ApiInterceptorService implements HttpInterceptor {

    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

    constructor(private router: Router, private matSnackBar: MatSnackBar, private tokenRefreshService: RefreshTokenService, private translateService: TranslateService,
        private snackbarService: SnackbarService
    ) {
    }
    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            tap((event: HttpEvent<unknown>) => {
                this.handleGraphqlResponse(event);
            }),
            catchError((err: HttpErrorResponse) => {
                if(err.status === 500 && Number(err.error.errors[0]?.['errorCode']) === 401) {
                    return this.handleTokenRefresh(request, next);
                }
                else {
                    return this.handleErrorResponse(err);
                }
            })
        );
    }
    private handleGraphqlResponse(event: HttpEvent<unknown>): void {
        if (event instanceof HttpResponse) {
            if (event.status >= 200 && event.status <= 400 && get(event, 'body.errors.length') && event.url.includes('graphql')) {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                // const messages: string[] = get(event, 'body.errors').map(error => error.message || error);
                const errorMessages: any[] = get(event, 'body.errors');
                const translatedMessages: string[] = [];

                errorMessages.forEach((error: any) => {
                    const translatedMessage = this.translateService.instant(error.message || error);
                    translatedMessages.push(translatedMessage);
                  });


                 this.snackbarService.showErrorSnackbar({
                    message: translatedMessages[0],
                 }).afterDismissed().subscribe(() => {
                    // localStorage.removeItem('token');
                    // this.router.navigate(['/sign-out']);
                });
            }
        }
    }
    private handleErrorResponse(errorResponse: HttpErrorResponse): Observable<never> {

        if (errorResponse.url.split('/').includes('graphql') && get(errorResponse, 'error.errors')) {
            return throwError(this.displayErrors(errorResponse.error.errors));
        } else {
            const errors: string[] = get(errorResponse, 'error.errors');
            if (errors && Array.isArray(errors)) {
                return throwError(this.displayErrors(errors));
            } else {
                if (Number(errorResponse.error?.error?.code) === -187) {
                    this.snackbarService.showErrorSnackbar({
                        message: this.translateService.instant(errorResponse.error?.error?.message),
                    }).afterDismissed().subscribe(() => {
                        window.open('https://eprintit.com', '_self');
                    });
                } else if (Number(errorResponse?.error?.error?.code) === -116) {
                    this.snackbarService.showErrorSnackbar({
                        message: this.translateService.instant(errorResponse.error?.error?.message),
                    }).afterDismissed().subscribe(() => {
                    });
                }
                else {
                   this.snackbarService.showErrorSnackbar({
                        message: this.translateService.instant(errorResponse.error?.error?.message),
                    }).afterDismissed().subscribe(() => {
                    });
                }
                return throwError(errorResponse);
            }
        }
    }


    private handleTokenRefresh(
        originalRequest: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('refreshToken');
        if (!token) {
            // If there's no token, user is not authenticated, redirect to login or sign-out page
            this.router.navigate(['/sign-out']);
            return throwError('User is not authenticated.');
        }

        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.tokenRefreshService.refreshToken(token).pipe(
                tap((newToken: any) => {
                    localStorage.setItem('token', newToken['data']['token']);
                    localStorage.setItem('refreshToken', newToken['data']['refreshToken']);
                    this.refreshTokenSubject.next(newToken['data']['token']);
                }),
                switchMap(() => {
                    // Clone the original request and add the new token to the headers
                    const clonedRequest = originalRequest.clone({
                        setHeaders: {
                            Authorization: `${localStorage.getItem('token')}`
                        }
                    });
                    // Retry the request with the updated headers
                    return next.handle(clonedRequest);
                }),
                catchError((err) => {
                    // Handle any errors that might occur during token refresh
                    // You can redirect to login or sign-out page or handle it based on your requirements

                    this.snackbarService.showErrorSnackbar({
                        message: this.translateService.instant('Session Timed Out'),
                    }).afterDismissed().subscribe(() => {
                    });

                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    this.router.navigate(['/sign-out']);
                    this.refreshTokenSubject.error(err);
                    this.refreshTokenSubject = new BehaviorSubject<string | null>(null);
                    return throwError('Token refresh failed.');

                }),
                finalize(() => {
                    this.isRefreshing = false;
                })
            );
        } else {
            return this.refreshTokenSubject.pipe(
                filter((tokenValue: string | null) => tokenValue !== null),
                take(1),
                switchMap(() => {
                    const clonedRequest = originalRequest.clone({
                        setHeaders: {
                            Authorization: `${localStorage.getItem('token')}`
                        }
                    });
                    return next.handle(clonedRequest);
                })
            );
        }
    }

    private displayErrors(errors: string[]): string {
        // eslint-disable-next-line @typescript-eslint/typedef
        let displayError = '';
        errors.forEach(err => displayError += ` ${err['message'] ? err['message'] : err}`);
        // errors[0]?.['message']
        this.snackbarService.showErrorSnackbar({
            message: this.translateService.instant('errorSomethingWentWrong'),
        }).afterDismissed().subscribe(() => {
        });
        setTimeout(() => {
            if(Number(errors[0]?.['errorCode']) === 401) {
                localStorage.removeItem('token');
                this.router.navigate(['/sign-out']);
            }
        },3000);
        return displayError;
    }


}
